export default "/images/custom_development/advanced_apple_development_environments__image.png";